<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import AppIcon from '@/components/AppIcon.vue'
import { icons } from '@/navigation'

const route = useRoute()

const title = computed(() => {
  const matched = [...route.matched].reverse().find((record) => record.meta?.mobileTitle)
  if (matched?.meta?.mobileTitle) return matched.meta.mobileTitle
  const segment = route.path.split('/').filter(Boolean)[0]
  if (!segment) return 'Home'
  return segment.charAt(0).toUpperCase() + segment.slice(1)
})

const icon = computed(() => {
  const matched = [...route.matched].reverse().find((record) => record.meta?.mobileIcon)
  return matched?.meta?.mobileIcon || icons.analysis
})
</script>

<template>
  <header class="mh">
    <RouterLink class="mh__brand" to="/home" aria-label="Home">
      <img src="/icon-512.png" alt="" width="32" height="32" />
    </RouterLink>
    <div class="mh__copy">
      <span class="mh__kicker">GMSomeday</span>
      <p class="mh__title">{{ title }}</p>
    </div>
    <span class="mh__view-icon" aria-hidden="true">
      <AppIcon :paths="icon" />
    </span>
  </header>
</template>

<style scoped>
.mh {
  display: none;
}

@media (max-width: 767px) {
  .mh {
    position: sticky;
    top: 0;
    z-index: 45;
    display: flex;
    align-items: center;
    gap: var(--space-sm);
    min-height: calc(58px + env(safe-area-inset-top, 0px));
    border-bottom: 1px solid var(--hairline);
    background: rgba(var(--paper-rgb), 0.96);
    padding: calc(var(--space-xs) + env(safe-area-inset-top, 0px)) var(--space-md) var(--space-xs);
    backdrop-filter: blur(14px);
    -webkit-backdrop-filter: blur(14px);
  }

  .mh__brand,
  .mh__view-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    width: 44px;
    height: 44px;
    border: 1px solid var(--hairline);
    border-radius: var(--radius-md);
    background: var(--surface-raised);
    color: var(--ink-gold);
  }

  .mh__brand {
    text-decoration: none;
  }

  .mh__brand img {
    width: 30px;
    height: 30px;
    object-fit: contain;
  }

  .mh__copy {
    min-width: 0;
    flex: 1 1 auto;
  }

  .mh__kicker {
    display: block;
    color: var(--ink-gold);
    font-family: var(--font-mono);
    font-size: 10px;
    font-weight: 500;
    line-height: 1.2;
    text-transform: uppercase;
  }

  .mh__title {
    overflow: hidden;
    padding-bottom: 2px;
    color: var(--ink);
    font-family: var(--font-display);
    font-size: var(--text-2xl);
    font-weight: 650;
    line-height: 1.14;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .mh__view-icon svg {
    width: 20px;
    height: 20px;
  }
}
</style>
